<template>
  <div 
    class="dictionary-search"
    ref="dictionary-search"
  >
    <h1 class="home__title dictionary__title">
      Словарь терминов
    </h1>
    
    <form
      action="/dictionary"
      class="dictionary-search__form"
      @submit.prevent="$emit('on-submit', name)"
    >
      <input
        ref="searchTermInput"
        :value="name"
        type="text"
        class="dictionary-search__input"
        autocorrect="off"
        spellcheck="false"
        autocomplete="off"
        placeholder="поиск по словарю"
        @input="onInputChange"
        @keydown.esc="cleanQueryText"
        @keydown.enter.exact.prevent
        @keyup.enter.exact="$emit('on-submit', name)"
        @keydown.enter.shift.exact="$emit('on-submit', name)"
      />
      
      <button class="button dictionary-search__button">
        Найти
      </button>
    </form>

    <div 
      v-if="noteName" 
      class="message"
    >
      {{ noteName }}
    </div>
    
    <div class="dictionary-search__terms">
      <div
        v-for="(term, k) in terms"
        :key="`${k}_${term.id}`"
        class="dictionary-search__term"
        :class="{ _selected: term.name === currentTermName }"
        @click="$emit('term-selected', term)"
      >
        {{ term.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    terms: {
      required: true
    },
    currentTermName: {
      required: true
    },
    currentRequest: {
      required: true
    },
    noteName: {
      required: true,
      default: () => ''
    }
  },

  data() {
    return {
      name: ''
    };
  },

  created() {
    this.name = this.currentRequest
  },

  watch: {
    currentRequest: function(newVal) {
      this.name = newVal
      this.$refs['dictionary-search'].scroll(0, 0)
    }
  },

  methods: {
    cleanQueryText() {
      this.$refs.searchTermInput.focus();
      this.name = '';
      this.$emit('clean-query-text');
    },
    onInputChange(e) {
      this.name = e.target.value.replace(/[\r\n\t]+/gm, '').trim();
    }
  }
};
</script>

<style src="./styles/index.css" />
